import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

// EN
import enSection from '../i18n/en.json';
// IT
import itSection from '../i18n/it.json';

// Import moment l10n.

import moment from 'moment';
import 'moment/locale/it';
import 'moment/locale/de';
import 'moment/locale/fr';
import 'moment/locale/pt';
import 'moment/locale/es';
import 'moment/locale/ro';


export function loadTranslations() {
    let translations = {
        en: enSection, //{},
        it: itSection //{}
    };

    // loadTranslation(translations.en, enSection);

    // loadTranslation(translations.it, itSection);

    return translations;
}

function loadTranslation(storage: any, section: any) {
    let prefix = section.section;

    for (let screen of section.screens) {
        for (let key in screen.keys) {
            let name = `${prefix}${key[0].toLocaleUpperCase()}${key.substring(1)}`;
            storage[name] = screen.keys[key];
        }
    }
}

import en_US from 'date-fns/locale/en-US';
import it from 'date-fns/locale/it';
export function getDateFnsLocale(locale: string, fallbackLocale: string) {
    function get(l: string) {
        switch (locale.substring(0, 2)) {
            case 'en':
            case 'en-US':
                return en_US;

            case 'it':
                return it;

            default:
                return null;
        }
    }

    return get(locale)
        || get(locale.substring(0, 2))
        || (fallbackLocale && get(fallbackLocale))
        || (fallbackLocale && get(fallbackLocale.substring(0, 2)));
}

let i18n: VueI18n;

export function init() {
    if (i18n == null) {
        // Setup localization.
        let locale = window.location.pathname.split('/')[1];
        if (locale && locale.length === 2) {
            moment.locale(locale);
        }
        else {
            locale = 'en';
            moment.locale('en');
        }

        i18n = new VueI18n({
            locale: locale,
            fallbackLocale: 'en',
            messages: loadTranslations()
        });
    }

    return i18n;
}

export function useI18n() {
    return i18n;
}
